import { useEffect } from "react"
import LimitField from "./LimitField.jsx"

// Filter prompts by which model they target — Lead step → prompts with model="Lead",
// Company step → prompts with model="Company".
const TARGET_MODEL = {
  "enrichment.lead":    "Lead",
  "enrichment.company": "Company"
}

export default function EnrichmentForm({ node, options, config, setConfig }) {
  const targetModel = TARGET_MODEL[node.data.stepType]
  const prompts = (options?.prompts ?? []).filter(p => p.model === targetModel)
  const models = options?.models ?? []
  const defaultModelId = options?.default_model_id

  // Seed the form's model_id default so clicking OK without touching the
  // dropdown still persists a model — otherwise the card's MODEL row stays
  // empty even though the dropdown looks pre-filled.
  useEffect(() => {
    if (config.model_id == null && defaultModelId != null) {
      setConfig({ ...config, model_id: defaultModelId })
    }
  }, [])

  const update = patch => setConfig({
    enrichment_type: config.enrichment_type ?? "Leads::Enrichments::Prompt",
    model_id: config.model_id ?? defaultModelId,
    ...config,
    ...patch
  })

  return (
    <div className="space-y-3">
      <label className="block">
        <span className="text-xs font-medium text-muted-foreground">Prompt ({targetModel})</span>
        <select value={config.prompt_id ?? ""}
                onChange={e => update({ prompt_id: Number(e.target.value) || null })}
                className="mt-1 w-full h-9 px-2 rounded-md border border-border bg-background text-sm">
          <option value="">Pick a prompt…</option>
          {prompts.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
        {prompts.length === 0 && (
          <p className="text-[11px] text-muted-foreground mt-1">
            No active {targetModel} prompts in this project. Create one under <strong>AI Prompts</strong>.
          </p>
        )}
      </label>

      <label className="block">
        <span className="text-xs font-medium text-muted-foreground">Model</span>
        <select value={config.model_id ?? defaultModelId ?? ""}
                onChange={e => update({ model_id: Number(e.target.value) || null })}
                className="mt-1 w-full h-9 px-2 rounded-md border border-border bg-background text-sm">
          <option value="">Pick a model…</option>
          {models.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>
      </label>

      <LimitField config={config} setConfig={update} />
    </div>
  )
}
